'use client';

import { useQuery } from '@tanstack/react-query';

import { getRecommendedArticlesQuery } from '@/features/articles';
import { Article } from './Article';

export const Recommended = () => {
  const { data } = useQuery(getRecommendedArticlesQuery({ limit: 5 }));

  const articles = data ?? [];

  if (!articles.length) return null;

  return <Article title="Рекомендуем" articles={articles} url="recommended" />;
};
